export default __webpack_public_path__ + "static/media/humedales.93491e80.jpg";